<template>
  <long-query-layout
    resource-name="umaoi-s"
    :query-filter="queryFilter"
    :map-query-filter-for-api="mapQueryFilterForApi"
    :apply-query-filter="applyQueryFilter"
    :active-tab.sync="activeTab"
    :customers.sync="customerCollection"
    :customer-download-only="true"
    @query-completed="loadData"
    @query-id-change="queryId = $event"
  >
    <!-- -------------------------------------------------------- -->
    <!-- ヘッダのアクション -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:header-actions="slotProps">
      <gl-switch
        :value="isDetail"
        :disabled="!(slotProps.queryId && activeTab == 'result')"
        @input="toggleDetail"
        >詳細</gl-switch
      >
    </template>
    <template v-slot:header-actions="slotProps">
      <gl-switch :value="isDetail" @input="toggleDetail">詳細</gl-switch>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析条件 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:filter>
      <!-- 期間 -->
      <query-filter-element
        id="term-compare"
        title="期間"
        contentWidth="medium"
      >
        <filter-term-compare v-bind.sync="queryFilter.term" />
      </query-filter-element>

      <!-- 店舗 -->
      <query-filter-element
        id="store-compare"
        title="店舗"
        contentWidth="medium"
      >
        <filter-store-compare v-bind.sync="queryFilter.store" />
      </query-filter-element>

      <!-- 顧客グループ -->
      <query-filter-element id="customer" title="顧客グループ">
        <filter-customer v-bind.sync="queryFilter.customer" />
      </query-filter-element>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析結果 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:result>
      <query-umaoi
        resource-name="umaoi-s"
        tab-label="店舗別"
        :is-detail="isDetail"
        :switch-column-model="switchColumnModel"
        :result-data.sync="resultData"
        :query-id="queryId"
        @echo-toggle-customer-collection="toggleCustomerCollection"
        ref="umaoi"
      />
    </template>
  </long-query-layout>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
import LongQueryLayout from '@/components/layout/LongQueryLayout.vue'
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterTermCompare from '@/components/FilterTermCompare.vue'
import FilterStoreCompare from '@/components/FilterStoreCompare.vue'
import FilterCustomer from '@/components/FilterCustomer.vue'
// 分析条件モデル
import termCompare from '@/queryfilter/termCompare'
import storeCompare from '@/queryfilter/storeCompare'
import customer from '@/queryfilter/customer'

import QueryUmaoi from '@/components/QueryUmaoi.vue'

export default {
  components: {
    QueryFilterElement,
    FilterTermCompare,
    FilterStoreCompare,
    FilterCustomer,
    LongQueryLayout,
    QueryUmaoi,
  },
  props: {
    /**
     * 自画面のドリルダウンや他画面からの遷移時に渡される引き継ぎID
     *
     * あくまで画面間で分析条件を引き継ぐための識別子で、分析時にサーバーで
     * 発行されるクエリIDとは別なので注意してください。
     *
     * メニューから最初に開く場合など、入力がない場合もあります。
     */
    inherit: {
      type: String,
    },
  },
  data() {
    return {
      queryId: undefined,
      /**
       * 表示タブ（分析条件、分析結果）
       *
       * 表示タブをプログラム側から切り替えたい場合をこれを使います。
       */
      activeTab: undefined,
      /**
       * 分析条件
       */
      queryFilter: {
        term: { order: 1, summaryKey: 'termCompare', ...termCompare.get() },
        store: {
          order: 2,
          summaryKey: 'storeCompare',
          ...storeCompare.get(),
          all: true,
        },
        customer: { order: 4, ...customer.get() },
      },
      /**
       * 分析情報
       */
      queryInfo: undefined,
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: queryFilter => ({
        term: termCompare.mapToApiPayload(queryFilter.term),
        store: storeCompare.mapToApiPayload(queryFilter.store),
        customer: customer.mapToApiPayload(queryFilter.customer),
      }),
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       *
       * 渡される分析条件はこの画面のものとは限らないので、"可能な限り"復元する。
       */
      applyQueryFilter: queryFilter => {
        termCompare.applyPayload(this.queryFilter.term, queryFilter.term)
        storeCompare.applyPayload(this.queryFilter.store, queryFilter.store)
        customer.applyPayload(this.queryFilter.customer, queryFilter.customer)
      },
      /**
       * 顧客コレクション
       */
      customerCollection: [],
      /**
       * 詳細表示
       */
      isDetail: false,
      /***
       *
       */
      switchColumnModel: {
        headerTextCode: '店舗コード',
        headerTextName: '店舗名',
        code: 'store_code',
        name: 'store_name',
        customerCount: 'store_customer_count',
        customerCountFilter: 'store_customer_count_filter',
      },
      resultData: {
        summary: {},
        switch: [],
      },
    }
  },
  methods: {
    /**
     * 詳細トグル制御
     */
    toggleDetail(value) {
      this.isDetail = value
    },
    /**
     * 統計側データを取得して表示
     */
    loadData() {
      this.$refs.umaoi.loadSummaryData()
    },
    /**
     * 顧客リスト操作
     */
    toggleCustomerCollection(customer) {
      this.$emit('toggle-customer-collection', customer)
    },
  },
}
</script>
